var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"businesses"},[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c(_vm.businessesTabComponent,{tag:"component",attrs:{"selectedContactId":_vm.selectedContactId,"selectedBusinessId":_vm.selectedBusinessId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }